import React from 'react';
// settings
// components

import StartColumnsContainer from 'modules/emergencies/components/ui/containers/startColumnsContainer';
import HeaderRow from 'modules/emergencies/components/ui/rows/headerRow';
import { SETTINGS } from 'modules/carriersv2/constants';
import HeaderColumn from 'modules/emergencies/components/ui/columns/headerColumn';
import HeaderText from 'modules/emergencies/components/ui/texts/HeaderText';
import styled from 'styled-components';

const CustomStartColumnsContainer = styled(StartColumnsContainer)`
  width: 100%;
`;

const columnWidths = SETTINGS.CARRIERS_TABLE_COLUMN_SIZES_IN_PX;
const headerColumns = {
  startColumns: [
    {
      width: columnWidths.NAME,
      text: 'NAME',
    },
    {
      width: columnWidths.EXTERNAL_ID,
      text: 'EXTERNAL ID',
    },
    {
      width: columnWidths.WORKING_AREAS,
      text: 'WORKING AREAS',
    },
    {
      width: columnWidths.RATING,
      text: 'RATING',
    },
  ],
};

const CarriersListTableHeaderRow = () => {
  return (
    <HeaderRow>
      <CustomStartColumnsContainer>
        {headerColumns.startColumns.map((column, index) => (
          <HeaderColumn key={index} width={column.width} centerContent={!!column.centerContent}>
            <HeaderText>{column.text}</HeaderText>
          </HeaderColumn>
        ))}
      </CustomStartColumnsContainer>
    </HeaderRow>
  );
};

export default CarriersListTableHeaderRow;
